/* eslint-disable */
require('./account_circle')
require('./add_circle_outline')
require('./add')
require('./admin_panel_settings')
require('./alert')
require('./apps')
require('./arrow_back')
require('./assignment_turned_in')
require('./assignment')
require('./attach_file')
require('./calendar')
require('./call_end')
require('./call')
require('./cancel_circle_outline')
require('./chart-bubble')
require('./chart')
require('./check_circle_outline')
require('./check')
require('./chevron_left_double')
require('./chevron_left')
require('./chevron_right_double')
require('./chevron_right')
require('./clear')
require('./clock')
require('./delete_forever')
require('./description')
require('./diabetes')
require('./dni')
require('./door-enter')
require('./edit')
require('./email')
require('./event_available')
require('./expand_more')
require('./fact_check')
require('./favorite')
require('./filter')
require('./fitness_center')
require('./forum')
require('./gauge')
require('./healing')
require('./highlight_off')
require('./history')
require('./house')
require('./human-male-height')
require('./id_card')
require('./image')
require('./info')
require('./insert_chart_outlined')
require('./institution')
require('./inventory')
require('./label')
require('./labs')
require('./link')
require('./list')
require('./local_hospital')
require('./local_pharmacy')
require('./location_on')
require('./lock_open')
require('./lock')
require('./logo-quantux-viejo')
require('./loyalty')
require('./lungs')
require('./man')
require('./medical_services')
require('./medical-specialty')
require('./medication')
require('./message')
require('./mic_off')
require('./mic')
require('./money')
require('./more_horiz')
require('./note_add')
require('./notifications_active')
require('./notifications_off')
require('./patient_list')
require('./pending_actions')
require('./people')
require('./perm_contact_calendar')
require('./person')
require('./phone_iphone')
require('./phonelink_erase')
require('./phonelink_ring')
require('./phonelink')
require('./pill')
require('./playlist_add')
require('./pulse')
require('./quantux-logo-horizontal-nuevo')
require('./quantux-logo-horizontal')
require('./radiology')
require('./refresh')
require('./reorder')
require('./reply')
require('./search')
require('./sentiment_satisfied_alt')
require('./settings')
require('./shoe-print')
require('./smartphone')
require('./stethoscope')
require('./thermometer')
require('./today')
require('./videocam_off')
require('./videocam')
require('./videogame')
require('./visibility')
require('./weight')
require('./woman')
